
import React, { Component } from 'react';
import { Bar, Pie } from 'react-chartjs-2';
import $ from 'jquery';
// import ReactTable from "react-table"
import DataTable from 'react-data-table-component';
// import jsPDF from "jspdf"
//  import html2canvas from "html2canvas";

export default class ViewSurveyReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      surveyQuestionsforBooleanType: [],
      surveyQuestionsforIntegerType: [],
      surveyAnswers: [],
      questionsId: [],
      SurveyQuestionsAndAnswers: [],
      noSurveyAnswers: false,
      allData: [],
      answersJson: [],
      countforBoolean: 0,
      surveyResultData: [],
      countforBooleanYes: [],
      countforBooleanNo: [],
      piedataforBoolean: [],
      countForYes: {},
      countForNo: {},
      integerAnswerSum: {},
      integerAverage: {},
      totalIntegeranswersCount: 0,
      surveyQuestionsforSelectType: [],
      selectTypeAnswerobject: {},
      surveyQuestions: [],
      surveyQuestionsforMultiSelectType: [],
      multiSelectTypeAnswerobject: {},
      integerTypeAnswerObject: {},
      answeredIntegerObject: {},
      isLoading : true,
    }
  }

  componentDidMount() {
    // this.fetchPatientName();
    this.fetchSurveyQuestion();
  }

  fetchSurveyQuestion() {
    var thisController = this;

    $.ajax({
      url: "/my-jeeva-api/fetch-survey-item",
      method: "GET",

      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        surveyId: localStorage.getItem("surveyId"),
      },
      success: function (res) {
        if (res.success == true) {
          var surveyQuestions = res.result;
          thisController.state.surveyQuestions = surveyQuestions;
          thisController.setState(thisController.state);
          for (var y = 0; y < res.result.length; y++) {
            if (surveyQuestions[y].type == "BOOLEAN") {
              thisController.state.surveyQuestionsforBooleanType.push(surveyQuestions[y]);
            } else if (surveyQuestions[y].type == "INTEGER") {
              thisController.state.surveyQuestionsforIntegerType.push(surveyQuestions[y]);
            } else if (surveyQuestions[y].type == "SELECT") {
              thisController.state.surveyQuestionsforSelectType.push(surveyQuestions[y]);
            } else {
              thisController.state.surveyQuestionsforMultiSelectType.push(surveyQuestions[y]);
            }
            thisController.setState(thisController.state);
          }
          thisController.fetchPatientName();
          thisController.setState(thisController.state);
        }
      },
    });
  }

  fetchSurveyAnswers() {
    var thisController = this;
    var surveyId = localStorage.getItem("surveyIdOfTreatment");

    $.ajax({
      url: "/my-jeeva-api/fetch-survey-results",
      method: "GET",

      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        answeredBy: localStorage.getItem("patientId"),
        surveyId: surveyId,
      },
      success: function (res) {
        if (res.success == true) {
          if (res.result.length == 0) {
            thisController.state.noSurveyAnswers = true;
            thisController.setState(thisController.state);
          } else {
            console.log(
              "Survey Answers From PatientSurveyResult:-  " + res.result
            );
            var result = res.result[0];
            thisController.state.noSurveyAnswers = false;
            thisController.setState(thisController.state);

          }
        }
      },
    });
  }

  fetchPatientName() {
    var thisController = this;

    $.ajax({
      url: "/my-jeeva-api/fetch-survey-results-patient",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        surveyId: localStorage.getItem("surveyId")
      },
      success: function (res) {
        if (res.success == true) {
          thisController.state.isLoading = false;
          thisController.setState(thisController.state);
          var surveyId = localStorage.getItem("surveyId");
          var patientSurveyData = res.result;
          for (var z = 0; z < patientSurveyData.length; z++) {
            if (surveyId == patientSurveyData[z].surveyId)
              if (patientSurveyData[z].answeredByName != null) {
                thisController.state.surveyResultData.push(patientSurveyData[z])
                thisController.state.answersJson.push(JSON.parse(patientSurveyData[z].answersJson));
                console.log("Answerjson array is" + thisController.state.answersJson);
                thisController.setState(thisController.state);

              }

          }
          thisController.printResolved();
        } else {
          thisController.state.isLoading = false;
          thisController.setState(thisController.state);
        }
      },
    });


  }

  printResolved = () => {

    var answersArray = [];
    var answersJson = this.state.answersJson;
    var questionsArray = this.state.questionsId;
    for (var s = 0; s < this.state.surveyQuestionsforBooleanType.length; s++) {
      for (var t = 0; t < answersJson.length; t++) {
        var answersJsonindividual = answersJson[t];
        var keys = Object.keys(answersJsonindividual);
        for (var u = 0; u < keys.length; u++) {
          if (this.state.surveyQuestionsforBooleanType[s].id == keys[u]) {
            var objectid = this.state.surveyQuestionsforBooleanType[s].id;
            var values = answersJsonindividual[objectid];
            if (values == "Yes") {
              if (this.state.countForYes[objectid]) {
                this.state.countForYes[objectid] = this.state.countForYes[objectid] + 1;
              } else {
                this.state.countForYes[objectid] = 1;
              }
              this.setState(this.state);
            } else if (values == "No") {
              if (this.state.countForNo[objectid]) {
                this.state.countForNo[objectid] = this.state.countForNo[objectid] + 1;
              } else {
                this.state.countForNo[objectid] = 1;
              }
              this.setState(this.state);
            }
            console.log("this.state.countForNo , {}" + this.state.countForNo);
            console.log("this.state.countForYes , {}" + this.state.countForYes);

            this.state.countforBoolean = this.state.countforBoolean + 1;
            console.log("Count for Boolean Answers " + this.state.countforBoolean);
            this.setState(this.state);

          }
        }

      }
    }

    for (var v = 0; v < this.state.surveyQuestionsforIntegerType.length; v++) {
      var answersCount = 0;
      var answerObject = {};
      var answeredIntegerArray = [];
      // var filterdIntegerarray = [];
      for (var w = 0; w < answersJson.length; w++) {
        var answersJsonindividual = answersJson[w];
        var keys = Object.keys(answersJsonindividual);
        for (var x = 0; x < keys.length; x++) {
          if (this.state.surveyQuestionsforIntegerType[v].id == keys[x]) {
            // this.state.totalIntegeranswersCount = this.state.totalIntegeranswersCount + 1;
            answersCount = answersCount + 1;
            var objectid = this.state.surveyQuestionsforIntegerType[v].id;
            var values = answersJsonindividual[objectid];
            // var convertedvalue = Number(values);
            // filterdIntegerarray.push(convertedvalue);
            // for(var ar = 0; ar < filterdIntegerarray.length ; ar++){
            //   if(filterdIntegerarray[ar] != convertedvalue){
            //     answeredIntegerArray.push(convertedvalue);
            //   }
            // }
            if (answerObject[values]) {
              answerObject[values] = answerObject[values] + 1;
            } else {
              answerObject[values] = 1;
            }
            if (this.state.integerAnswerSum[objectid]) {
              this.state.integerAnswerSum[objectid] = this.state.integerAnswerSum[objectid] + Number(values);
            } else {
              this.state.integerAnswerSum[objectid] = Number(values);
            }
            this.state.integerAverage[objectid] = this.state.integerAnswerSum[objectid] / answersCount;
            this.setState(this.state);

          }
        }

      }
      this.state.integerTypeAnswerObject[this.state.surveyQuestionsforIntegerType[v].id] = answerObject;
      answeredIntegerArray = Object.keys(answerObject);
      this.state.answeredIntegerObject[this.state.surveyQuestionsforIntegerType[v].id] = answeredIntegerArray;
      this.setState(this.state);
    }

    for (var i = 0; i < this.state.surveyQuestionsforSelectType.length; i++) {
      var answerObject = {};
      var optionsArray = [];
      optionsArray = this.state.surveyQuestionsforSelectType[i].options.split(",");

      for (var j = 0; j < answersJson.length; j++) {
        var answersJsonindividual = answersJson[j];
        var keys = Object.keys(answersJsonindividual);
        for (var k = 0; k < keys.length; k++) {
          if (this.state.surveyQuestionsforSelectType[i].id == keys[k]) {
            var objectid = this.state.surveyQuestionsforSelectType[i].id;
            var values = answersJsonindividual[objectid];
            for (var l = 0; l < optionsArray.length; l++) {
              if (optionsArray[l] == values) {
                if (answerObject[optionsArray[l]]) {
                  answerObject[optionsArray[l]] = answerObject[optionsArray[l]] + 1;
                } else {
                  answerObject[optionsArray[l]] = 1;
                }

              }
            }
            this.setState(this.state);
          }
        }
      }
      this.state.selectTypeAnswerobject[this.state.surveyQuestionsforSelectType[i].id] = answerObject;
      this.setState(this.state);
    }

    for (var m = 0; m < this.state.surveyQuestionsforMultiSelectType.length; m++) {
      var answerObject = {};
      var optionsArray = [];
      optionsArray = this.state.surveyQuestionsforMultiSelectType[m].options.split(",");

      for (var n = 0; n < answersJson.length; n++) {
        var answersJsonindividual = answersJson[n];
        var keys = Object.keys(answersJsonindividual);
        for (var p = 0; p < keys.length; p++) {
          if (this.state.surveyQuestionsforMultiSelectType[m].id == keys[p]) {
            var objectid = this.state.surveyQuestionsforMultiSelectType[m].id;
            var valuesArray = answersJsonindividual[objectid];
            for (var q = 0; q < optionsArray.length; q++) {
              for (var r = 0; r < valuesArray.length; r++) {
                if (optionsArray[q] == (valuesArray[r])) {
                  if (answerObject[optionsArray[q]]) {
                    answerObject[optionsArray[q]] = answerObject[optionsArray[q]] + 1;
                  } else {
                    answerObject[optionsArray[q]] = 1;
                  }

                }
              }
            }
            this.setState(this.state);
          }
        }
      }
      this.state.multiSelectTypeAnswerobject[this.state.surveyQuestionsforMultiSelectType[m].id] = answerObject;
      this.setState(this.state);
    }

  };

  sectionPieChart(question) {

    var colorsArray = ['aqua', 'blue', 'fuchsia', 'navy', 'lime',
      'maroon', 'grey', 'olive', 'purple', 'purple',
      '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
      '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
      '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', 
		  '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
		  '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
      'silver', 'teal', 'orange', '#99E6E6', '#6666FF'];

    var selectOptionArray = [];
    if (question.type == "SELECT") {
      selectOptionArray = question.options.split(",")
      var selectoptionslength = selectOptionArray.length
      var selectColors = colorsArray.slice(0, selectoptionslength);
    }



    if (question.type == "SELECT") {
      var selectDataArray = [];
      var dataObject = {};
      dataObject = this.state.selectTypeAnswerobject[question.id]
      if (dataObject) {
        for (var a = 0; a < selectOptionArray.length; a++) {
          if (dataObject[selectOptionArray[a]] == undefined) {
            selectDataArray.push(0);
          } else {
            selectDataArray.push(dataObject[selectOptionArray[a]])
          }
        }
      }
    }

    var multiSelectOptionsArray = [];
    if (question.type == "MULTISELECT") {
      multiSelectOptionsArray = question.options.split(",")
      var multiSelectoptionslength = multiSelectOptionsArray.length
      var multiSelectColors = colorsArray.slice(-multiSelectoptionslength);

    }
    var multiSelectDataArray = [];
    if (question.type == "MULTISELECT") {
      var dataObject = {};
      dataObject = this.state.multiSelectTypeAnswerobject[question.id]
      if (dataObject) {
        for (var b = 0; b < multiSelectOptionsArray.length; b++) {
          if (dataObject[multiSelectOptionsArray[b]] == undefined) {
            multiSelectDataArray.push(0);
          } else {
            multiSelectDataArray.push(dataObject[multiSelectOptionsArray[b]]);
          }
        }
      }
    }

    var integerDataArray = [];
    var labelsArray = [];
    if (question.type == "INTEGER") {
      var dataObject = {};
      labelsArray = this.state.answeredIntegerObject[question.id];
      if (labelsArray) {
        var labelsArrayLength = labelsArray.length;
        var integerColors = colorsArray.slice(10, colorsArray.length - labelsArrayLength);
      }
      dataObject = this.state.integerTypeAnswerObject[question.id]
      if (dataObject) {
        for (var d = 0; d < labelsArray.length; d++) {
          if (dataObject[labelsArray[d]] == undefined) {
            integerDataArray.push(0);
          } else {
            integerDataArray.push(dataObject[labelsArray[d]]);
          }

        }
      }
    }

    let getPiedataforBoolean = {
      labels: ['Yes', "No"],
      datasets: [
        {
          data: [this.state.countForYes[question.id], this.state.countForNo[question.id]],
          backgroundColor: ['green', 'red'],
        },
      ],
    }

    let getPiedataforSelect = {
      labels: selectOptionArray,
      datasets: [
        {
          data: selectDataArray,
          backgroundColor: selectColors
        },
      ],
      hoverOffset: 6
    }

    let getPiedataforMultiSelect = {
      labels: multiSelectOptionsArray,
      datasets: [
        {
          data: multiSelectDataArray,
          backgroundColor: multiSelectColors,
        },
      ],
      hoverOffset: 6
    }

    let getPiedataforInteger = {
      labels: labelsArray,
      datasets: [
        {
          data: integerDataArray,
          backgroundColor: integerColors,
        },
      ],
      hoverOffset: 6
    }

    switch (question.type) {
      case "INTEGER":

        if (dataObject) {
          return (
            <div
              style={{
                height: "30rem", width: "60rem",
                display: "flex", alignContent: "stretch", justifyContent: "center",
                flexWrap: "wrap", flexDirection: "column"
              }}>

              <Pie data={getPiedataforInteger} />

             {this.state.integerAverage[question.id] ? 
             <h5>Average is : &nbsp;
             {
               Math.round(this.state.integerAverage[question.id] * 100) / 100
             } </h5> : <h5>Average is : &nbsp;0</h5> }
              
              <br />

              {labelsArray.map((options) => (
                dataObject[options] ? 
                <h6> 
                   {options + " : " + (
                  dataObject[options] * 100)
                  / this.state.surveyResultData.length}  %
              </h6> : <h6>{options + " : " + 0}  %</h6>
              ))
              }

            </div>
          );
        }

      case "BOOLEAN":

        return (

          <div
            style={{
              height: "30rem", width: "60rem",
              display: "flex", alignContent: "stretch", justifyContent: "center",
              flexWrap: "wrap", flexDirection: "column"
            }}
          >
            <Pie data={getPiedataforBoolean} />
            {this.state.countForYes[question.id] ? 
            <h6>
              Yes :{((this.state.countForYes[question.id] * 100) / this.state.surveyResultData.length)} %
            </h6> : <h6>Yes : 0 %</h6> }
            {this.state.countForNo[question.id] ? <h6>
              No : {(this.state.countForNo[question.id] * 100) / this.state.surveyResultData.length} %
            </h6> : <h6>No : 0 %</h6>}
           

          </div>

        );
      case "SELECT":
        if (dataObject) {
          return (
            <div style={{
              height: "30rem", width: "60rem",
              display: "flex", alignContent: "stretch", justifyContent: "center",
              flexWrap: "wrap", flexDirection: "column"
            }}>
              <Pie data={getPiedataforSelect} />
              {selectOptionArray.map((options) => (
                dataObject[options] ? 
                  <h6> 
                     {options + " : " + (
                    dataObject[options] * 100)
                    / this.state.surveyResultData.length}  %
                </h6> : <h6>{options + " : " + 0}  %</h6> 
                
              ))
              }

            </div>
          );
        }

      case "MULTISELECT":
        if (dataObject) {
          return (
            <div
              style={{
                height: "30rem", width: "60rem", 
                display: "flex", alignContent: "stretch", justifyContent: "center",
                flexWrap: "wrap", flexDirection: "column"
              }}
            >
              <Pie data={getPiedataforMultiSelect} />
              {multiSelectOptionsArray.map((options) => (
                dataObject[options] ? 
                <h6 style={{color:"black"}}> 
                   {options + " : " + (
                  dataObject[options] * 100)
                  / this.state.surveyResultData.length}  %
              </h6> : <h6>{options + " : " + 0}  %</h6> 
              ))
              }

            </div>
          );
        }
    }
  }


  render() {
    return (
      <div>
        <div style={{
          marginTop: "25px"
        }}>  {this.state.isLoading && (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>Loading ...</p>
          </div>
        )}
        </div>
        <div style={{
          marginTop: "25px"
        }}> {!this.state.isLoading && this.state.surveyResultData.length == 0 && (
          <h5 align="center" style={{ fontSize: "20px", fontWeight: "400",color:"black"}} > No patient attended this survey yet.</h5>
        )}
        </div>

        <div>
          {!this.state.isLoading && this.state.surveyResultData.length > 0 && <div
            style={{ marginLeft: "2vw" }}
          >
            <div style={{ display: "flex"}}> <h3 style={{color:"rgb(40, 42, 101)",textDecoration:"underline",textDecorationColor:"rgb(40, 42, 101)"}}>{localStorage.getItem("surveyTitle")}</h3> </div>
            <div className='no-print'>
              <button className='btn2 table-action-button ' style={{marginLeft:"96rem",marginTop:"-2rem"}} onClick={() => window.print()}>Download Reports</button>
            </div>
            <h5 style={{ fontSize: "22px", marginTop: "1rem"}}>The total number of patients who participated in this survey is&nbsp;
              {this.state.surveyResultData.length}</h5>

            {this.state.surveyQuestions.map((question, i) => (
              <div key={i}>
                <div
                >
                  <div className="col-sm-9 " Align="left">
                    <div
                    >
                    </div>
                    <h3 style={{ fontSize: "20px", marginTop: "8vh"}}>
                      {(i + 1) + "." + this.state.surveyQuestions[i].question}
                    </h3>
                    <div style={{ marginTop: "5vh" }}> {
                      this.sectionPieChart(question)
                    }
                    </div>
                  </div>
                </div>

              </div>
            ))}
          </div>}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ViewSurveyReports.js